// FILE: src/pages/BillingCanceled.jsx
import React from "react";
import { Link } from "react-router-dom";
import Menu from "../Menu";

export default function BillingCanceled() {
  const [showMenu, setShowMenu] = React.useState(false);

  return (
    <div style={{ minHeight: "100vh", background: "#223b4c", color: "#f8faff" }}>
      {/* Top Bar with Menu Button */}
      <div
        style={{
          width: "100vw",
          padding: "14px 16px",
          background: "rgba(20,15,44,0.55)",
          display: "flex",
          alignItems: "center",
          gap: 12,
          position: "sticky",
          top: 0,
          zIndex: 999,
        }}
      >
        <button
          aria-label="Open menu"
          title="Menu"
          onClick={() => setShowMenu(true)}
          style={{
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.16)",
            color: "#ffe066",
            fontWeight: 900,
            borderRadius: 12,
            padding: "10px 14px",
            cursor: "pointer",
          }}
        >
          ☰ Menu
        </button>

        <div style={{ marginLeft: 8, fontWeight: 900, color: "#f8faff" }}>
          Checkout cancelled
        </div>
      </div>

      {/* Sidebar instance */}
      <Menu open={showMenu} onClose={() => setShowMenu(false)} />

      {/* Page content */}
      <div style={{ maxWidth: 680, margin: "40px auto", padding: 24 }}>
        <h1 style={{ marginTop: 0 }}>🛑 Checkout cancelled</h1>
        <p>No charge was made. You can try again any time.</p>
        <Link to="/pricing">
          <button
            style={{
              padding: "10px 16px",
              borderRadius: 12,
              border: "1px solid rgba(255,255,255,0.18)",
              background: "rgba(32,30,48,0.58)",
              color: "#f8faff",
              cursor: "pointer",
            }}
          >
            Back to Pricing
          </button>
        </Link>
      </div>
    </div>
  );
}
